import React, {useEffect, useState} from 'react';
import BlogTable from './BlogTable';
import AppsContainer from '@crema/core/AppsContainer';
import {useIntl} from 'react-intl';
import {useDispatch, useSelector} from 'react-redux';
import {setPage, setSearch} from 'redux/actions/ExclusiveProperty';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import AppsContent from '@crema/core/AppsContainer/AppsContent';
import AppsPagination from '@crema/core/AppsPagination';
import {Input, Button, Typography, Modal} from 'antd';
import './index.style.less';
import AppPageMetadata from '@crema/core/AppPageMetadata';
import ModalCloseConfirm from 'lib/components/ModalCloseConfirm';
import AddBlog from './AddBlog';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import {getBlogs} from 'redux/actions/Blog';

const debounceSearchOrder = AwesomeDebouncePromise(
  (search, dispatch) => {
    dispatch(setSearch(search));
    dispatch(setPage(1));
  },
  500,
  {
    onlyResolvesLast: true,
  },
);

const Blogs = () => {
  const {messages} = useIntl();
  const dispatch = useDispatch();
  const {blogs, blogCount, page, search} = useSelector(({blog}) => blog);

  const {loading} = useSelector(({common}) => common);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const onChange = (page) => {
    dispatch(setPage(page));
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const showShowModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };
  useEffect(() => {
    dispatch(getBlogs());
  }, [dispatch, search, page]);

  const onSearchOrder = (e) => {
    debounceSearchOrder(e.target.value, dispatch);
  };

  useEffect(() => {
    return () => {
      dispatch(setPage(1));
      dispatch(setSearch(''));
    };
  }, []);

  return (
    <>
      <AppPageMetadata title='Blogs' />
      <AppsContainer
        title={messages['sidebar.admin.blogs']}
        fullView
        type='bottom'>
        <AppsHeader key={'wrap'}>
          <div className='customer-header'>
            <div className='customer-header-input-view'>
              <Input
                id='user-name'
                placeholder='Search'
                type='search'
                onChange={onSearchOrder}
              />
            </div>
            <Typography style={{padding: '0 0.5rem'}}>
              Total: {blogCount}
            </Typography>
            <div className='customer-header-right'>
              <Button type='primary' onClick={() => showShowModal()}>
                Add Blog
              </Button>
              <AppsPagination
                className='customer-header-pagination'
                pageSize={10}
                current={page}
                count={blogCount}
                page={page}
                onChange={onChange}
              />
            </div>
          </div>
        </AppsHeader>
        <AppsContent
          key={'wrap1'}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}>
          <BlogTable loading={loading} propertyData={blogs} />
        </AppsContent>
        <AppsPagination
          key={'wrap2'}
          className='customer-footer-pagination'
          pageSize={10}
          current={page}
          count={blogCount}
          page={page}
          onChange={onChange}
        />
      </AppsContainer>
      <Modal
        title={messages['admin.addAdvertisement']}
        visible={isModalVisible}
        onOk={handleOk}
        footer={false}
        maskClosable={false}
        destroyOnClose={true}
        width={800}
        closeIcon={<ModalCloseConfirm onCancel={handleCancel} />}>
        <AddBlog closeModel={handleCancel} />
      </Modal>
    </>
  );
};

export default Blogs;
